'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat(chatId, pharmacy) {
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_chatId = null;
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_pharmacy = null;
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_chatId = chatId;
  this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_pharmacy = pharmacy;
}
export { $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat as $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat };
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.constructor = $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat;
/** @constructor */
function $h_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat() {
}
export { $h_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat as $h_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat };
$h_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype = $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype;
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1156258160), true);
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat)) {
    var x = this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_chatId;
    var x$2 = x$0.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_chatId;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_pharmacy;
      var x$4 = x$0.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_pharmacy;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.productPrefix__T = (function() {
  return "SendEpsCodeFromChat";
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_chatId;
  }
  if ((n === 1)) {
    return this.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat__f_pharmacy;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "chatId";
  }
  if ((n === 1)) {
    return "pharmacy";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat)));
}
export { $isArrayOf_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat as $isArrayOf_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat };
var $d_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat, "app.pages.AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat", ({
  Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat as $d_Lapp_pages_AppPage$DrugRequestsListOutstanding$SendEpsCodeFromChat };
//# sourceMappingURL=app.pages.-App-Page$-Drug-Requests-List-Outstanding$-Send-Eps-Code-From-Chat.js.map
